export const primary_brand = "#e6662c";
export const secondary_brand = "#4492CF";
export const tertiary_brand = "#f3d9da";
export const hoverSecondarySelect = "#3b25a8";
export const success = "#31d0aa";
export const error = "#FF0D3B";
export const subtle_text = "#8c8ca1";

export const ligthColor = "#FAFCFE";

export const errorBg = "#B74D33";

export const Processing = "#ffbc0d";
